import GoodwinLogo from '../assets/images/logo/logo_goodwin_icon.png'
import CrazywinLogo from '../assets/images/logo/crazywin.svg'
import DarkGoodwinLogo from '../assets/images/logo/dark_logo_goodwin.png'
import RunPayLogo from '../assets/images/logo/logo_runpay_icon.svg'
import SobflousLogo from '../assets/images/logo/logo_sobflous_icon.svg'
import LettobetLogo from '../assets/images/logo/logo_lettobet_icon.svg'
import LettobetRedLogo from '../assets/images/logo/lettobet_for_login.svg'
import MaksiparaLogo from '../assets/images/logo/maksi/logo_para_img.png'

const Logos: { [key: string]: string } = {
    'goodwin': GoodwinLogo,
    'crazywin': CrazywinLogo,
    'runpay': RunPayLogo,
    'sobflous': SobflousLogo,
    'lettobet': LettobetLogo,
    'maksipara': MaksiparaLogo,
}

export const LoginLogosLight: { [key: string]: string } = {
    'goodwin': GoodwinLogo,
    'crazywin': CrazywinLogo,
    'lettobet': LettobetRedLogo,
}

export const LoginLogosDark: { [key: string]: string } = {
    'goodwin': DarkGoodwinLogo,
    'crazywin': CrazywinLogo,
    'lettobet': LettobetRedLogo,
}

export default Logos